// extracted by mini-css-extract-plugin
export default {"flag":"web-only-flag__flag___1WVRF","flag-icon":"web-only-flag__flag-icon___1EvnI"};